import { WidgetContainer } from '@/components/analytics/WidgetContainer';
import type { MasteredQuestion } from '@/types/analytics';
import styles from './QuestionsMastered.module.scss';

export interface QuestionsMasteredProps {
  data: MasteredQuestion[] | null;
  isLoading?: boolean;
  error?: Error | null;
  limit?: number;
}

export function QuestionsMastered({ data, isLoading, error, limit = 10 }: QuestionsMasteredProps) {
  const isEmpty = !data || data.length === 0;

  const masteredQuestions = data
    ? data.filter((q) => q.successRate >= 90).slice(0, limit)
    : [];

  return (
    <WidgetContainer
      title="Questions Mastered"
      description="Questions with 90%+ success rate"
      isLoading={isLoading}
      error={error}
      isEmpty={isEmpty}
      emptyMessage="Practice more to master questions"
      size="medium"
    >
      <div className={styles.questionsMastered}>
        <div className={styles.questionsMastered__header}>
          <span className={styles.questionsMastered__count}>
            {masteredQuestions.length}
          </span>
          <span className={styles.questionsMastered__label}>
            Question{masteredQuestions.length !== 1 ? 's' : ''} Mastered
          </span>
        </div>

        <div className={styles.questionsMastered__list}>
          {masteredQuestions.map((q) => (
            <div key={q.questionId} className={styles.questionsMastered__item}>
              <span className={styles.questionsMastered__check}>✓</span>
              <span className={styles.questionsMastered__text}>{q.questionText}</span>
              <span className={styles.questionsMastered__rate}>
                {q.successRate.toFixed(0)}%
              </span>
            </div>
          ))}
        </div>
      </div>
    </WidgetContainer>
  );
}
